import { render, staticRenderFns } from "./batteryType.vue?vue&type=template&id=37fa100a&scoped=true&"
import script from "./batteryType.vue?vue&type=script&lang=js&"
export * from "./batteryType.vue?vue&type=script&lang=js&"
import style0 from "./batteryType.vue?vue&type=style&index=0&id=37fa100a&prod&lang=less&scoped=true&"
import style1 from "./batteryType.vue?vue&type=style&index=1&id=37fa100a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa100a",
  null
  
)

export default component.exports